











 













const node = {
  "kind": "InlineDataFragment",
  "name": "useGetUsedServiceTaskIds_phase"
};

(node ).hash = "892664b2e6ea5caf4bc3e5e3f5eee31c";

export default node;
